__webpack_require__.p = "https://static.targe.singles/";